import {PastCallsRepository} from "../../domain/types";
import {PastCallsRepositoryV2} from "./repository.v2";

export type {PastCallsRepository} from "../../domain/types";

/**
 * Creates the PastCallsRepository. V1 has been fully retired — this always
 * returns the v2 implementation.
 *
 * @example
 * const repository = createPastCallsRepository();
 * const pastCalls = await repository.getCoachPastCalls({ page: 1, perPage: 5 });
 */
export const createPastCallsRepository = (): PastCallsRepository => {
  return new PastCallsRepositoryV2();
};
